import React, { useState } from 'react';
import { Mail, Phone, MapPin, ArrowRight } from 'lucide-react';
import Header from './components/Header10';
import Footer from './components/Footer10';

const Contact10 = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: '',
    });
    const [submitted, setSubmitted] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitted(true);
        setTimeout(() => {
            setSubmitted(false);
            setFormData({ name: '', email: '', message: '' });
        }, 3000);
    };

    const inputClass = "w-full px-0 py-3.5 bg-transparent text-[#1C1917] text-sm font-light placeholder-[#A8A29E] focus:outline-none transition-colors duration-300";

    return (
        <>
            <link href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&display=swap" rel="stylesheet" />

            <div style={{ fontFamily: "'Inter', sans-serif" }} className="min-h-screen bg-white">
                <Header />

                <main className="pt-16 md:pt-[72px]">
                    {/* Page Header */}
                    <div className="py-12 md:py-20 px-5 md:px-8 text-center" style={{ borderBottom: '1px solid #E7E5E4' }}>
                        <p className="text-[#A8A29E] text-[10px] md:text-xs tracking-[3px] uppercase mb-3">Reach Out</p>
                        <h1 className="text-2xl md:text-4xl font-light text-[#1C1917] tracking-tight">Get in Touch</h1>
                    </div>

                    <div className="max-w-[1000px] mx-auto px-5 md:px-8 py-12 md:py-20">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 md:gap-24">
                            {/* Contact Form */}
                            <div>
                                {submitted ? (
                                    <div className="py-12 text-center">
                                        <p className="text-[#1C1917] text-lg font-light mb-2">Thank you.</p>
                                        <p className="text-[#78716C] text-sm font-light">We will be in touch shortly.</p>
                                    </div>
                                ) : (
                                    <form onSubmit={handleSubmit}>
                                        <div style={{ borderBottom: '1px solid #E7E5E4' }}>
                                            <input
                                                type="text"
                                                name="name"
                                                placeholder="Your Name"
                                                value={formData.name}
                                                onChange={handleInputChange}
                                                className={inputClass}
                                                style={{ fontFamily: "'Inter', sans-serif" }}
                                                required
                                            />
                                        </div>
                                        <div style={{ borderBottom: '1px solid #E7E5E4' }}>
                                            <input
                                                type="email"
                                                name="email"
                                                placeholder="Email"
                                                value={formData.email}
                                                onChange={handleInputChange}
                                                className={inputClass}
                                                style={{ fontFamily: "'Inter', sans-serif" }}
                                                required
                                            />
                                        </div>
                                        <div style={{ borderBottom: '1px solid #E7E5E4' }}>
                                            <textarea
                                                name="message"
                                                placeholder="Your Message"
                                                value={formData.message}
                                                onChange={handleInputChange}
                                                rows="4"
                                                className="w-full px-0 py-3.5 bg-transparent text-[#1C1917] text-sm font-light placeholder-[#A8A29E] focus:outline-none resize-none"
                                                style={{ fontFamily: "'Inter', sans-serif" }}
                                                required
                                            />
                                        </div>

                                        <button
                                            type="submit"
                                            className="mt-8 inline-flex items-center gap-3 py-3 bg-transparent text-[#78716C] text-xs tracking-[2px] uppercase font-normal hover:text-[#1C1917] transition-colors duration-300 cursor-pointer border-none"
                                        >
                                            Send Message <ArrowRight className="w-3.5 h-3.5" strokeWidth={1.5} />
                                        </button>
                                    </form>
                                )}
                            </div>

                            {/* Contact Info */}
                            <div className="space-y-10">
                                <div>
                                    <div className="flex items-center gap-3 mb-3">
                                        <Mail className="w-4 h-4 text-[#78716C]" strokeWidth={1.5} />
                                        <p className="text-[#1C1917] text-xs tracking-[2px] uppercase">Email</p>
                                    </div>
                                    <p className="text-[#78716C] text-sm font-light">hello@sthir.in</p>
                                </div>

                                <div>
                                    <div className="flex items-center gap-3 mb-3">
                                        <Phone className="w-4 h-4 text-[#78716C]" strokeWidth={1.5} />
                                        <p className="text-[#1C1917] text-xs tracking-[2px] uppercase">Phone</p>
                                    </div>
                                    <p className="text-[#78716C] text-sm font-light">+91 98765 43210</p>
                                </div>

                                <div>
                                    <div className="flex items-center gap-3 mb-3">
                                        <MapPin className="w-4 h-4 text-[#78716C]" strokeWidth={1.5} />
                                        <p className="text-[#1C1917] text-xs tracking-[2px] uppercase">Studio</p>
                                    </div>
                                    <p className="text-[#78716C] text-sm font-light leading-relaxed">
                                        By appointment only<br />
                                        Mumbai, Maharashtra<br />
                                        India
                                    </p>
                                </div>

                                <div className="pt-4" style={{ borderTop: '1px solid #E7E5E4' }}>
                                    <p className="text-[#A8A29E] text-xs font-light leading-relaxed">
                                        Monday - Friday: 10:00 - 18:00<br />
                                        Saturday: 11:00 - 16:00<br />
                                        Sunday: Closed
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>

                <Footer />
            </div>
        </>
    );
};

export default Contact10;
